<script setup>
import ChangeDevices from "@/components/Common/ChangeDevices.vue";
import { useDeviceState } from "@/stores/deviceState";
import { onUnmounted } from "vue";
import { ref, onMounted, watch } from "vue";

const deviceState = useDeviceState();
const localVideo = ref(null);
const stream = ref(null);

onMounted(async () => {
  await deviceState.ready;
  deviceState.cameraPermission.addEventListener("change", () => {
    deviceChanged();
  });
  deviceState.microphonePermission.addEventListener("change", () => {
    deviceChanged();
  });
  await deviceState.checkPermissions();
  deviceChanged();

  DrawRedFrame();
});

onUnmounted(() => {
  if (stream.value) {
    stream.value.getTracks().forEach((track) => track.stop());
  }
});

async function deviceChanged() {
  try {
    if (stream.value) {
      stream.value.getTracks().forEach((track) => track.stop());
    }
    const input = await deviceState.getUserMedia();
    watch(
      input,
      (newStream) => {
        if (stream.value) {
          stream.value.getTracks().forEach((track) => track.stop());
        }

        stream.value = newStream;

        if (localVideo.value) {
          localVideo.value.srcObject = newStream;
        }
      },
      { immediate: true },
    );
    console.log("device changed");
  } catch (err) {
    alert(err);
  }
}

function DrawRedFrame(data = { width: 1080, height: 2400 }){
  const canvas = document.getElementById('agent-preview-red-frame');
  if (canvas && canvas.getContext) {
    canvas.style.display = 'inline';
    const ctx = canvas.getContext("2d");
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.lineWidth = "2";
    ctx.strokeStyle = "red";

    const widthMargin = 20;
    
    if(data.width > data.height){
      const ratio = data.width / canvas.width;
      const newHeight = data.height / ratio;

      ctx.strokeRect(0, (canvas.height - newHeight) / 2, canvas.width, newHeight);
    }
    else {
      const ratio = data.height / canvas.height;
      const newWidth = data.width / ratio;

      ctx.strokeRect(((canvas.width - newWidth) / 2) - widthMargin, 0, newWidth + (widthMargin * 2), canvas.height);
    }
  }
}
</script>
<template>
  <v-container>
    <v-card style="position: relative; z-index: 1">
      <v-card-title>Agent Preview</v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12" md="6">
            <div class="agent-preview-video-wrapper">
              <video muted class="agent-video-call" ref="localVideo" autoplay />
              <canvas id="agent-preview-red-frame"></canvas>
            </div>
          </v-col>

          <v-col cols="12" md="6">
            <change-devices @device-changed="deviceChanged"></change-devices>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<style>
.agent-video-call {
  width: 100%;
  height: 100%;
  border: 1px solid aliceblue;
  transform: rotateY(180deg);
  display: block;
}

.agent-preview-video-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
}

#agent-preview-red-frame {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 10; /* higher than video */
  display: none;
  pointer-events: none; /* ensures clicks go through to video if needed */
}
</style>
